export const filterABPlaneBodySizesWithoutRollover = (flight) => {
    return (flight.planeBodySize === "A" || flight.planeBodySize === "B") && !flight.rollover;
};
export const filterCPlaneBodySize = (flight) => {
    return flight.planeBodySize === "C";
};
export const filterDEFPlaneBodySizesWithWidebodyWithoutRollover = (flight) => {
    return ((flight.planeBodySize === "D" || flight.planeBodySize === "E" || flight.planeBodySize === "F") &&
        flight.widebody &&
        !flight.rollover);
};
export const filterDEFPlaneBodySizesWithWidebodyWithRollover = (flight) => {
    return ((flight.planeBodySize === "D" || flight.planeBodySize === "E" || flight.planeBodySize === "F") &&
        flight.widebody &&
        flight.rollover);
};
export const filterUnknownPlaneBodySize = (flight) => {
    return !flight.planeBodySize;
};
export const groupPlaneBodySize = (segments) => {
    return {
        abPlaneBodySizes: segments.map((segment) => segment.flights.filter(filterABPlaneBodySizesWithoutRollover).length),
        cPlaneBodySizes: segments.map((segment) => segment.flights.filter(filterCPlaneBodySize).length),
        dfPlaneBodySizes: segments.map((segment) => segment.flights.filter(filterDEFPlaneBodySizesWithWidebodyWithoutRollover).length),
        extraTime: segments.map((segment) => segment.flights.filter(filterDEFPlaneBodySizesWithWidebodyWithRollover).length),
        planeBodySizeUnknown: segments.map((segment) => segment.flights.filter(filterUnknownPlaneBodySize).length),
    };
};
export const getHandlerFlightCapacities = (segments) => {
    const handlerFlightCapacities = segments.map((segment) => segment.handlerCapacityForSegment === 0
        ? null // Exclude points with a value of 0
        : segment.handlerCapacityForSegment >= 20
            ? 20
            : segment.handlerCapacityForSegment);
    return handlerFlightCapacities;
};
export const getPadFlightCapacities = (segments) => {
    const padFlightCapacities = segments.map((segment) => segment.padCapacityForSegment === 0
        ? null // Exclude points with a value of 0
        : segment.padCapacityForSegment >= 20
            ? 20
            : segment.padCapacityForSegment);
    return padFlightCapacities;
};
